export default "__VITE_ASSET__CO_7qIRH__"